import React from 'react';

const FundingRosterPagination = ({
  page,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

  return (
    <div className="fg-roster-pagination" data-testid="funding-roster-pagination">
      <div className="fg-pagination-summary">
        Page <span>{page}</span> of <span>{totalPages}</span>
      </div>
      <div className="fg-pagination-controls">
        <select
          className="fg-page-size-select"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          aria-label="Rows per page"
        >
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        <button
          type="button"
          className="fg-pagination-btn"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Prev
        </button>
        <button type="button" className="fg-pagination-page active" aria-current="page">
          {page}
        </button>
        <button
          type="button"
          className="fg-pagination-btn"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default FundingRosterPagination;
